
/* ==========================================================================
   ▼▼▼  EVERYTHING YOU EDIT IS IN THIS ONE BLOCK  ▼▼▼
   ========================================================================== */
const CONFIG = {
  version: "v3.2 · Claude Fable 5.1 · 2026-09-03",

  /* 1. PRICES AND CART LINKS — `was` must be the real list price in the shop.
     t3 `was` = 59.90 + 59.90 + Everything 24.99 + Life 17.99 + ADHD Life 18.99
                + Budget Printable 12.99 + Gratitude 12.99 + Fitness 14.99 = 222.74
     (live site prices read from thesheetflow.com/products.json on 03.09.2026;
      the six printable variant ids in the t3 url are the real ones). */
  tiers: {
    t1: { was: 59.90,  now: 29.95, url: "/cart/45774260895853:1" },
    t2: { was: 119.80, now: 47.90, url: "/cart/45774261846125:1" },
    t3: { was: 222.74, now: 69.95, url: "/cart/45774261977197:1" }
  },

  /* 2. DEADLINE — one fixed date for everyone. null = no sale, no countdown, no top bar */
  saleEndsAt: "2026-09-13T03:59:59Z",

  /* 3. HERO BADGES — off until you switch them on. Set to what is actually true. */
  badges: { rating: null, ratingCount: null, bestseller: false },

  /* 4. REVIEWS — section stays hidden while empty.
        { name:"Sarah M.", place:"Ohio", stars:5, verified:true, date:"August 2026", text:"…" } */
  reviews: [],

  /* 5. SIMULATOR — the example numbers from the demo */
  sim: { safe: 535.58, spent: 141.75, days: 13 },

  /* 6. MARQUEE — the strip under the hero */
  marquee: ["One number, already after bills","Works offline","No account, no bank login","Pay once, keep forever",
            "5 languages","38 currencies","Undo on everything","Three-paycheck months found for you",
            "Print any screen","Try the whole app free"],

  /* 7. THE 13-SCREEN GALLERY */
  screens: [
    { tab:"Today",     img:"app-today",     h:900, t:"The number, and where it came from", d:"Safe to spend, days to payday, what you have spent today, the next bill and the next payday. The panel on the right shows every line that made the number." },
    { tab:"Log",       img:"app-log",       h:900, t:"Three seconds, then back out", d:"Amount, category, done. Your usual spends sit at the top as one-tap presets, and the category is already picked for you." },
    { tab:"Bills",     img:"app-bills",     h:900, t:"Nothing arrives as a surprise", d:"Autopay marked, paid ones ticked off, and the total still to come this period sitting at the top where you can see it." },
    { tab:"Envelopes", img:"app-envelopes", h:900, t:"Money that is already spoken for", d:"Fill an envelope and it leaves safe-to-spend immediately. Planned, spent and left, for every one of them." },
    { tab:"Calendar",  img:"app-calendar",  h:900, t:"The month, and the year behind it", d:"The whole month on one grid with paydays tinted, and twelve months at a glance so nothing hides in November." },
    { tab:"Paychecks", img:"app-paychecks", h:900, t:"Six paydays ahead", d:"Three-paycheck months found and flagged. Log a bonus, a side job or a paycheck that came in different and the period recalculates." },
    { tab:"Goals",     img:"app-goals",     h:900, t:"Tell it the price and the date", d:"It divides the goal per payday, not per month, because that is how you are actually paid. Milestones along the way so it is not one flat bar for eleven months." },
    { tab:"Debt",      img:"app-debt",      h:900, t:"A real debt-free date", d:"Snowball or avalanche, compared side by side, with the honest interest figure and a date that moves every time you pay something off." },
    { tab:"Accounts",  img:"app-accounts",  h:900, t:"Where the money actually is", d:"Your accounts and balances, kept by you, never connected to any bank and never sent anywhere." },
    { tab:"Wait list", img:"app-waitlist",  h:900, t:"Forty-eight hours of nothing happening", d:"Park the impulse buy. The app asks again in two days, and shows you what all your no answers have added up to." },
    { tab:"Routines",  img:"app-routines",  h:900, t:"The same short payday checklist", d:"The five things you do every payday, in the same order, ticked off. No decisions required." },
    { tab:"Insights",  img:"app-insights",  h:900, t:"Where it actually went", d:"In against out, spending by category, debt falling, goals filling, over six or twelve periods. Charts that answer a question." },
    { tab:"Settings",  img:"app-settings",  h:900, t:"Everything is yours to change", d:"Language, currency, palette, light or dark, corners, density, text size, pay cycle, backup and CSV export." }
  ]
};
/* ==========================================================================
   ▲▲▲  NOTHING BELOW HERE NEEDS EDITING  ▲▲▲
   ========================================================================== */
const money = n => "$" + n.toLocaleString("en-US",{minimumFractionDigits:2, maximumFractionDigits:2});
const pctOff = t => Math.floor((1 - t.now / t.was) * 100);
const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

for (const [key, t] of Object.entries(CONFIG.tiers)) {
  document.querySelectorAll(`[data-price="${key}"]`).forEach(el => el.textContent = money(t.now));
  document.querySelectorAll(`[data-was="${key}"]`).forEach(el => el.textContent = money(t.was));
  document.querySelectorAll(`[data-off="${key}"]`).forEach(el => el.textContent = pctOff(t) + "% OFF");
  document.querySelectorAll(`[data-save="${key}"]`).forEach(el => el.textContent = `You save ${money(t.was - t.now)} — ${pctOff(t)}% off`);
  document.querySelectorAll(`[data-buy="${key}"]`).forEach(el => el.href = t.url);
}
const yrEl = document.getElementById("yr"); if (yrEl) yrEl.textContent = new Date().getFullYear();

/* badges */
(function(){
  const b = CONFIG.badges, box = document.getElementById("badges");
  let html = `<span class="lpb-badge lpb-sale">Launch price · ${pctOff(CONFIG.tiers.t1)}% off</span>`;
  if (b.bestseller) html += `<span class="lpb-badge lpb-best">Bestseller</span>`;
  if (b.rating) { const f = Math.round(b.rating);
    html += `<span class="lpb-badge lpb-stars"><b>${"★".repeat(f)}${"☆".repeat(5-f)}</b> ${b.rating.toFixed(1)}${b.ratingCount ? ` · ${b.ratingCount} reviews` : ``}</span>`; }
  box.innerHTML = html;
})();

/* marquee */
(function(){
  const t = document.getElementById("marquee");
  const items = CONFIG.marquee.map(s => `<span>${s}</span>`).join("");
  t.innerHTML = items + items;
})();

/* scroll reveal + counters + progress */
(function(){
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add("lpb-in");
    e.target.querySelectorAll("[data-count]").forEach(runCount);
    if (e.target.matches("[data-count]")) runCount(e.target);
    io.unobserve(e.target);
  }), { rootMargin: "0px 0px -10% 0px", threshold: .12 });
  document.querySelectorAll(".lpb-rv, .lpb-stagger").forEach(el => io.observe(el));
  function runCount(el){
    if (el.dataset.done) return; el.dataset.done = 1;
    const to = parseFloat(el.dataset.count), dec = +(el.dataset.dec||0), pre = el.dataset.prefix||"";
    if (reduced) { el.textContent = pre + to.toLocaleString("en-US",{minimumFractionDigits:dec,maximumFractionDigits:dec}); return; }
    const t0 = performance.now(), dur = 1500;
    (function f(now){ const p = Math.min(1,(now-t0)/dur), e = 1-Math.pow(1-p,3);
      el.textContent = pre + (to*e).toLocaleString("en-US",{minimumFractionDigits:dec,maximumFractionDigits:dec});
      if (p<1) requestAnimationFrame(f); })(t0);
  }
  const bar = document.getElementById("progress");
  addEventListener("scroll", () => { const h = document.documentElement; bar.style.width = (h.scrollTop/(h.scrollHeight-h.clientHeight)*100)+"%"; }, {passive:true});
})();

/* live simulator */
(function(){
  const S = CONFIG.sim; let safe = S.safe, spent = S.spent; const stack = [];
  const big = document.getElementById("simBig"), day = document.getElementById("simDay"), sp = document.getElementById("simSpent"),
        tot = document.getElementById("simTotal"), toast = document.getElementById("simToast"), ttxt = document.getElementById("simToastTxt");
  document.getElementById("simDays").textContent = S.days + " days";
  let shown = safe, raf, hideT;
  function render(){ big.textContent = money(shown); day.textContent = money(shown / S.days); }
  function tween(){
    cancelAnimationFrame(raf);
    if (reduced) { shown = safe; render(); return; }
    const from = shown, t0 = performance.now(), dur = 650;
    (function f(now){ const p = Math.min(1,(now-t0)/dur), e = 1-Math.pow(1-p,3);
      shown = from + (safe-from)*e; render(); if (p<1) raf = requestAnimationFrame(f); })(t0);
  }
  function apply(){ sp.textContent = money(spent); tot.textContent = money(safe); tween();
    big.classList.remove("lpb-bump"); void big.offsetWidth; big.classList.add("lpb-bump"); }
  document.querySelectorAll(".lpb-spend").forEach(b => b.addEventListener("click", () => {
    const v = +b.dataset.v; stack.push(v); safe -= v; spent += v; apply();
    ttxt.textContent = `Logged ${b.dataset.n} — ${money(v)}`; toast.classList.add("lpb-on");
    clearTimeout(hideT); hideT = setTimeout(() => toast.classList.remove("lpb-on"), 3800);
  }));
  document.getElementById("simUndo").addEventListener("click", () => {
    const v = stack.pop(); if (v == null) return; safe += v; spent -= v; apply();
    ttxt.textContent = `Undone — ${money(v)} back`; clearTimeout(hideT); hideT = setTimeout(() => toast.classList.remove("lpb-on"), 1800);
  });
  big.addEventListener("click", () => {
    const box = document.querySelector(".lpb-simmath"); box.scrollIntoView({behavior: reduced?"auto":"smooth", block:"center"});
    box.style.boxShadow = "0 0 0 3px var(--clay)"; setTimeout(() => box.style.boxShadow = "", 900);
  });
  render();
})();

/* countdown */
(function(){
  const box = document.getElementById("countdown"), bar = document.getElementById("lpb-topbar");
  if (!CONFIG.saleEndsAt) { box.style.display="none"; bar.style.display="none"; return; }
  const end = new Date(CONFIG.saleEndsAt);
  const te = document.getElementById("topEnds"); if (te) te.textContent = end.toLocaleDateString("en-US",{month:"long",day:"numeric",timeZone:"America/New_York"});
  const val = document.getElementById("cdVal"); let last = "";
  const tick = () => { const ms = end - new Date();
    if (ms <= 0) { box.style.display="none"; bar.style.display="none"; return; }
    const d = Math.floor(ms/864e5), h = Math.floor(ms/36e5)%24, m = Math.floor(ms/6e4)%60, s = Math.floor(ms/1e3)%60;
    const txt = d > 0 ? `${d}d ${h}h ${m}m ${s}s` : `${h}h ${m}m ${s}s`;
    if (txt !== last) { val.textContent = txt; last = txt; if (!reduced) { val.classList.remove("lpb-tick"); void val.offsetWidth; val.classList.add("lpb-tick"); } } };
  tick(); setInterval(tick, 1000);
})();

/* gallery */
(function(){
  const tabs = document.getElementById("tabs"), panels = document.getElementById("panels");
  CONFIG.screens.forEach((s,i) => {
    const b = document.createElement("button"); b.className="lpb-tab"; b.setAttribute("role","tab"); b.setAttribute("aria-selected", i===0?"true":"false"); b.textContent = s.tab; b.dataset.i = i; tabs.appendChild(b);
    const p = document.createElement("div"); p.className="lpb-panel"; p.dataset.p = i; if (i) p.hidden = true;
    const ph = s.img.replace("app-","phone-");
    p.innerHTML = `<div class="lpb-frame lpb-zoom"><picture><source media="(max-width:719px)" width="600" height="1298" srcset="https://cdn.shopify.com/s/files/1/0712/0027/6589/files/${ph}_sm.webp 300w, https://cdn.shopify.com/s/files/1/0712/0027/6589/files/${ph}.webp 600w" sizes="74vw"><img src="https://cdn.shopify.com/s/files/1/0712/0027/6589/files/${s.img}.webp" srcset="https://cdn.shopify.com/s/files/1/0712/0027/6589/files/${s.img}_sm.webp 700w, https://cdn.shopify.com/s/files/1/0712/0027/6589/files/${s.img}.webp 1400w" sizes="(min-width:1240px) 1200px, 96vw" width="1400" height="${s.h}" loading="lazy" alt="${s.t}"></picture></div><div class="lpb-cap"><h3>${s.t}</h3><p>${s.d}</p></div>`;
    panels.appendChild(p);
  });
  tabs.addEventListener("click", e => { const b = e.target.closest(".lpb-tab"); if (!b) return;
    [...tabs.children].forEach(x => x.setAttribute("aria-selected", String(x===b)));
    [...panels.children].forEach(p => { p.hidden = p.dataset.p !== b.dataset.i; }); });
})();

/* reviews */
(function(){
  const R = (CONFIG.reviews||[]).filter(r => r && r.name && r.text); if (!R.length) return;
  document.getElementById("reviews").hidden = false;
  const avg = R.reduce((s,r)=>s+r.stars,0)/R.length, rd = Math.round(avg);
  document.getElementById("revAvg").textContent = avg.toFixed(1); document.getElementById("revCount").textContent = R.length;
  document.getElementById("revStars").textContent = "★".repeat(rd)+"☆".repeat(5-rd);
  document.getElementById("revBars").innerHTML = [5,4,3,2,1].map(s => { const n = R.filter(r=>r.stars===s).length, p = Math.round(n/R.length*100);
    return `<div class="lpb-bar"><span>${s}★</span><span class="lpb-track"><span class="lpb-fill" style="width:${p}%"></span></span><span>${n}</span></div>`; }).join("");
  document.getElementById("revList").innerHTML = R.map(r => `<div class="lpb-rev"><div class="lpb-who"><div class="lpb-av">${r.name.trim().charAt(0).toUpperCase()}</div><div><div class="lpb-nm">${r.name}${r.place?" · "+r.place:""}</div>${r.verified?'<div class="lpb-vf">Verified purchase</div>':""}</div></div><div class="lpb-stars" style="font-size:15px">${"★".repeat(r.stars)}${"☆".repeat(5-r.stars)}</div><p style="margin-top:8px">${r.text}</p>${r.date?`<p style="font-size:12.5px;margin-top:10px;opacity:.7">${r.date}</p>`:""}</div>`).join("");
})();

/* lightbox */
(function(){
  const lb = document.getElementById("lb"), im = lb.querySelector("img");
  document.addEventListener("click", e => { const z = e.target.closest(".lpb-zoom");
    if (z) { const s = z.querySelector("img")||z; im.src = s.currentSrc||s.src; im.alt = s.alt||""; lb.classList.add("lpb-on"); return; }
    if (e.target.closest("#lb")) lb.classList.remove("lpb-on"); });
  document.addEventListener("keydown", e => { if (e.key==="Escape") lb.classList.remove("lpb-on"); });
})();

/* ---- anchor scroll corrector ----
   Якщо під час smooth-скролу догрузиться картинка вище цілі і сторінка виросте,
   ціль з'їде вниз. Дотягуємо, поки не станемо рівно. Скасовується, щойно
   користувач сам почав гортати. */
(function(){
  const OFF = 18;
  let timer = null;
  function lock(el){
    let tries = 0;
    clearInterval(timer);
    timer = setInterval(() => {
      const d = el.getBoundingClientRect().top - OFF;
      if (Math.abs(d) <= 2 || ++tries > 45) { clearInterval(timer); return; }
      window.scrollBy({ top: d, behavior: "auto" });
    }, 90);
  }
  addEventListener("click", e => {
    const a = e.target.closest('a[href*="#"]');
    if (!a) return;
    const href = a.getAttribute("href") || "";
    const id = href.slice(href.indexOf("#") + 1);
    if (!id) return;
    const el = document.getElementById(id);
    if (!el) return;
    setTimeout(() => lock(el), 600);
  }, true);
  addEventListener("wheel", () => clearInterval(timer), {passive:true});
  addEventListener("touchstart", () => clearInterval(timer), {passive:true});
})();

/* sticky bar */
(function(){
  const bar = document.getElementById("lpb-sticky"), anchor = document.querySelector(".lpb-hero");
  new IntersectionObserver(([e]) => bar.classList.toggle("lpb-on", !e.isIntersecting), { rootMargin:"-120px 0px 0px 0px" }).observe(anchor);
})();
